// removed by extract-text-webpack-plugin
module.exports = {"TextButton":"_1oi6fjTBgUuSwqa1jpImSl","TextButton--small":"_1HoDiPWyxh3rSAr45aCP82"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TextButton/TextButton.scss
// module id = 2693
// module chunks = 0